import { render, staticRenderFns } from "./gDatatable.vue?vue&type=template&id=78f17882&"
import script from "./gDatatable.vue?vue&type=script&lang=js&"
export * from "./gDatatable.vue?vue&type=script&lang=js&"
import style0 from "./gDatatable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gDatatable.vue"
export default component.exports